import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import React, {useEffect} from "react";
import {fetchNotApplicableList} from "../../store/list-slice";
import {getDetailData} from "../../models/recurringExpenseModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import {fetchRecurringExpenseById} from "../../store/recurring-expense-slice";

const RecurringExpenseDetails = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.transaction);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.recurringExpense);

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchRecurringExpenseById({...userRole, id: params.recurringExpenseId}));
    }, [dispatch, params.recurringExpenseId, userRole]);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    const item = items.find(item => item.id === params.recurringExpenseId);
    const detailData = getDetailData({item, list});
    return (
        <>
            <SubHeader title="Recurring Expense Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>}
            </div>
        </>
    )
}

export default RecurringExpenseDetails;